import React from 'react';
import { ImageFile } from '~/data/types/images';

const OnlinePriceWrapper: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 161 50"
    >
      <path
        d="M159 30.9099C159 41.6795 123.63 48.4099 80 48.4099C36.3695 48.4099 1 43.1795 1 32.4099C1 21.6404 53 5.40632 97.5 6.90994C109.366 6.55165 130.944 9.20626 133 10.4062C133 12.4062 133 14.5112 133 15.4062C133.451 16.0142 134.352 16.7869 136.5 16.9062C141.926 18.8385 138.312 17.4978 143 19.4062C159.5 26.9062 159 25.0736 159 30.9099Z"
        fill="#FFFEFE"
      />
      <path
        d="M132.882 9.07896C103.331 5.61222 37.1985 3.74884 9.07087 24.0293C-26.0887 49.3798 79.2412 50.0509 119.338 46.1298C143.329 43.7836 159 38.0432 159 29.738C159 22.5878 131.787 11.8415 82.5365 13.8728"
        stroke="#00D6D1"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.6101 3.6499L43.8108 6.04862C43.9285 6.2841 44.1556 6.44739 44.419 6.48517L47.105 6.8718C47.7687 6.96762 48.0327 7.77191 47.5525 8.23276L45.6101 10.0991C45.4193 10.2826 45.3324 10.5465 45.3775 10.8056L45.8359 13.4404C45.9488 14.0922 45.2551 14.5895 44.6619 14.2812L42.2612 13.0363C42.0258 12.9141 41.744 12.9141 41.5079 13.0363L39.1072 14.2812C38.5141 14.5895 37.8203 14.0922 37.9339 13.4404L38.3916 10.8056C38.4368 10.5465 38.3499 10.2826 38.159 10.0991L36.2167 8.23276C35.7364 7.77191 36.0005 6.96762 36.6641 6.8718L39.3501 6.48517C39.6135 6.44739 39.8413 6.2841 39.959 6.04862L41.159 3.6499C41.4559 3.0568 42.3132 3.0568 42.6101 3.6499Z"
        fill="#E5F6F8"
        stroke="#FBE64D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Component>
  );
};

export default OnlinePriceWrapper;
